import styled from "styled-components";

const buttonStyleOnlyProps = new Set(["primary", "showloader", "padding"]);
const shouldForwardButtonProp = prop => !buttonStyleOnlyProps.has(prop);

const UIWidgetsButton = styled.button.withConfig({
  shouldForwardProp: shouldForwardButtonProp,
})`
  font: inherit;
  position: relative;
  font-size: ${props => props.theme.font12};
  line-height: ${props => props.theme.lineHeight12};
  border: 1px solid
    ${props =>
      props.primary
        ? props.theme.primaryHoverBlue
        : props.theme.borderLightGrey};
  background-color: ${props =>
    props.primary ? props.theme.lightBlue : props.theme.brandWhite};
  padding: ${props =>
    props.padding
      ? props.padding
      : `${props.theme.paddingHalfEm} ${props.theme.paddingOneAndQuarterEm}`};
  color: ${props =>
    props.primary ? props.theme.brandWhite : props.theme.textGrey};
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  pointer-events: ${props => (props.showloader ? "none" : "all")};
  opacity: ${props => (props.showloader ? "0.9" : "1")};
  opacity: ${props => (props.disabled ? "0.5" : "1")};
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")} !important;
  img {
    display: ${props => (props.showloader ? "block" : "none")};
    margin: auto;
    width: 36%;
    height: 50%;
    top: 23%;
    left: 33%;
    position: absolute;
  }
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
    color: ${props =>
      props.primary ? props.theme.brandWhite : props.theme.borderLightGrey};
    background-color: ${props =>
      props.primary ? props.theme.primaryDisabledBlue : props.theme.brandWhite};
    border: 1px solid
      ${props =>
        props.primary
          ? props.theme.primaryDisabledBorder
          : props.theme.greyLight};
  }
  transition: background-color 0.2s;
  &:hover:not(:disabled) {
    background-color: ${props => props.primary
        ? props.theme.primaryHoverBlue
        : props.theme.backgroundDarkGrey};
    border: 1px solid
      ${props => props.primary
          ? props.theme.primaryHoverBlue
          : props.theme.secondaryHoverBlue};
  }
`;

export default UIWidgetsButton;
